module.exports = __webpack_public_path__ + "static/coffeewaffle-bce202fbab94081938351d8ad1f13324.jpeg";